module.exports = __webpack_public_path__ + "img/69.8176b47f.jpg";